// import { ApolloClient, InMemoryCache, ApolloProvider, useQuery } from '@apollo/client';
import DisplayData from '../DisplayData'; import { Link } from 'react-router-dom';
import { Tabs } from '../Common/Tabs';
function Directory() {
    return ( 
        
        <>
            <Tabs />
        </>

     );
}

export default Directory;